import { Box, styled } from '@mui/material';

export const Wrapper = styled(Box)`
  background: ${({ theme }) => theme.palette.primary.contrastText};
  border-radius: ${({ theme }) => theme.radius?.md};
  box-shadow: 0px 2px 20px rgba(12, 32, 45, 0.1);
  padding: ${({ theme }) => theme.spacing(2)};
  height: 100%;
`;
